<div class="flex min-h-full flex-col justify-center px-6 py-12 lg:px-8">
  <div class="sm:mx-auto sm:w-full sm:max-w-sm">
    <img alt="Norupe logo" src="assets/logo.svg" class="mx-auto h-10 w-auto" />
  </div>

  <div class="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
    <div>
      <div>
        <a
          class="flex w-full justify-center rounded-md bg-green-700 px-3 py-1.5 text-sm/6 font-semibold text-white shadow-xs hover:bg-green-600"
          [href]="loginUrl"
        >
          Pieslēgties sistēmai
        </a>
      </div>
    </div>
  </div>
</div>
